import _ from 'lodash';
import helpers from '@/services/simulator/get-info-from-combined-cards/helpers';
import utilities from '@/services/utilities/utilities';
import constants from '@/services/constants';
import getHandInfo from '@/services/simulator/get-info-from-combined-cards/get-hand-info';

export default {
  run: function (holeCards, communityCards, handInfo, usingAtLeastOneHoleCard, shortDeck) {
    let drawInfo = {};
    let straightDrawInfoFromCommunityCards = {};

    if (communityCards.length >= 3) {
      if (shortDeck && handInfo.value >= 7) {
        return drawInfo;
      } else if (!shortDeck && handInfo.value >= 6) {
        return drawInfo;
      }
    }

    this._checkForFlushDraws(holeCards, communityCards, drawInfo, usingAtLeastOneHoleCard, shortDeck);

    // player has a straight
    if (handInfo.value === 5) {
      return drawInfo;
    }

    if (usingAtLeastOneHoleCard) {
      this._checkForStraightDraws([], communityCards, straightDrawInfoFromCommunityCards, false, shortDeck);
      this._checkForStraightDraws(holeCards, communityCards, drawInfo, straightDrawInfoFromCommunityCards, shortDeck);
    } else {
      this._checkForStraightDraws(holeCards, communityCards, drawInfo, false, shortDeck);
    }

    if (
      usingAtLeastOneHoleCard &&
      holeCards.length > 0 &&
      (
        handInfo.name === 'high card' ||
        (handInfo.name === 'pair' && handInfo.type !== 'overpair')
      )
    ) {
      this._checkForTopPairDraw(holeCards, communityCards, drawInfo);
    }

    return drawInfo;
  },
  _checkForFlushDraws: function (holeCards, communityCards, drawInfo, usingAtLeastOneHoleCard, shortDeck) {
    let cardsBySuit = helpers.getCardsBySuit(_.union(holeCards, communityCards));

    this.__checkForFourCardFlushDraw(holeCards, communityCards, cardsBySuit, drawInfo, usingAtLeastOneHoleCard, shortDeck);

    if (!drawInfo.flush && communityCards.length === 3) {
      this.__checkForBackdoorFlushDraw(holeCards, communityCards, cardsBySuit, drawInfo, usingAtLeastOneHoleCard, shortDeck);
    }
  },
  __checkForFourCardFlushDraw: function (holeCards, communityCards, cardsBySuit, drawInfo, usingAtLeastOneHoleCard, shortDeck) {
    let self = this;

    _.forEach(cardsBySuit, function (cardsOfSuit, suit) {
      if (cardsOfSuit.length === 4) {
        if (
          usingAtLeastOneHoleCard &&
          !cardsOfSuit.includes(holeCards[0]) &&
          !cardsOfSuit.includes(holeCards[1])
        ) {
          return;
        }

        let nutLevel = self.___getFlushDrawNutLevel(suit, holeCards, communityCards, shortDeck);
        let nutLevelCamelCase;

        if (nutLevel === 'nut') {
          nutLevelCamelCase = 'nut';
        } else if (nutLevel === 'second nut') {
          nutLevelCamelCase = 'secondNut';
        } else if (nutLevel === 'third nut') {
          nutLevelCamelCase = 'thirdNut';
        } else if (nutLevel === 'weak') {
          nutLevelCamelCase = 'weak';
        }

        drawInfo.flush = {
          id: `flushDraw:${nutLevelCamelCase}`,
          type: 'four card',
          nutLevel: nutLevel,
          suit: suit
        };
      }
    });
  },
  ___getFlushDrawNutLevel: function (flushSuit, holeCards, communityCards, shortDeck) {
    let highestFlushDrawRankFromHoleCards;
    let communityCardFlushRanks;
    let unusedRanks;
    let nutLevelIndex;

    highestFlushDrawRankFromHoleCards = this.____getHighestFlushDrawRankFromHoleCards(holeCards, flushSuit);
    communityCardFlushRanks = communityCards
      .filter(function (communityCard) {
        return communityCard[1] === flushSuit;
      })
      .map(function (communityCard) {
        return communityCard[0];
      })
    ;
    unusedRanks = constants.ranks.filter(function (rank) {
      let isACommunityCardFlushRank;
      let makesARoyalOrStraightFlush;

      isACommunityCardFlushRank = communityCardFlushRanks.includes(rank);
      if (isACommunityCardFlushRank) {
        return false;
      }

      if (shortDeck) {
        makesARoyalOrStraightFlush = !!getHandInfo._checkForFiveOrMoreRanksInARowShortDeck(
          _.union(communityCardFlushRanks, [rank]).sort(utilities.ranks.sortRanksDescendingCompareFunction)
        );
      } else {
        makesARoyalOrStraightFlush = !!getHandInfo._checkForFiveOrMoreRanksInARow(
          _.union(communityCardFlushRanks, [rank]).sort(utilities.ranks.sortRanksDescendingCompareFunction)
        );
      }

      if (makesARoyalOrStraightFlush) {
        return false;
      }

      return true;
    });
    nutLevelIndex = unusedRanks.indexOf(highestFlushDrawRankFromHoleCards);

    if (nutLevelIndex === 0) {
      return 'nut';
    } else if (nutLevelIndex === 1) {
      return 'second nut';
    } else if (nutLevelIndex === 2) {
      return 'third nut';
    } else if (nutLevelIndex >= 3 && nutLevelIndex <= 13) {
      return 'weak';
    } else if (nutLevelIndex !== -1) {
      throw new Error('Invalid value of nutLevelIndex.');
    }
  },
  ____getHighestFlushDrawRankFromHoleCards: function (holeCards, flushSuit) {
    let holeCardsWithFlushDraw = holeCards.filter(function (holeCard) {
      return holeCard[1] === flushSuit;
    });

    return utilities.ranks.getHighestRankFromCards(holeCardsWithFlushDraw);
  },
  __checkForBackdoorFlushDraw: function (holeCards, communityCards, cardsBySuit, drawInfo, usingAtLeastOneHoleCard, shortDeck) {
    let self = this;

    _.forEach(cardsBySuit, function (cardsOfSuit, suit) {
      if (cardsOfSuit.length === 3) {
        if (
          usingAtLeastOneHoleCard &&
          !cardsOfSuit.includes(holeCards[0]) &&
          !cardsOfSuit.includes(holeCards[1])
        ) {
          return;
        }

        let nutLevel = self.___getFlushDrawNutLevel(suit, holeCards, communityCards, shortDeck);
        let nutLevelCamelCase;

        if (nutLevel === 'nut') {
          nutLevelCamelCase = 'nut';
        } else if (nutLevel === 'second nut') {
          nutLevelCamelCase = 'secondNut';
        } else if (nutLevel === 'third nut') {
          nutLevelCamelCase = 'thirdNut';
        } else if (nutLevel === 'weak') {
          nutLevelCamelCase = 'weak';
        }

        drawInfo.flush = {
          id: `backdoorFlushDraw:${nutLevelCamelCase}`,
          type: 'backdoor',
          nutLevel: nutLevel,
          suit: suit
        };
      }
    });
  },
  _checkForStraightDraws: function (holeCards, communityCards, drawInfo, straightDrawInfoFromCommunityCards, shortDeck) {
    let rankIndexes;

    if (shortDeck) {
      rankIndexes = utilities.ranks.getRankIndexesFromCardsShortDeck(_.union(holeCards, communityCards), true);
    } else {
      rankIndexes = utilities.ranks.getRankIndexesFromCards(_.union(holeCards, communityCards), true);
    }

    this.__checkForOpenEndedStraightDraw(rankIndexes, drawInfo, straightDrawInfoFromCommunityCards, shortDeck);

    if (!drawInfo.straight) {
      this.__checkForDoubleGutshotStraightDraw(rankIndexes, drawInfo, straightDrawInfoFromCommunityCards);
    }

    if (!drawInfo.straight) {
      this.__checkForGutshotStraightDraw(rankIndexes, drawInfo, straightDrawInfoFromCommunityCards, shortDeck);
    }

    if (!drawInfo.straight && communityCards.length === 3) {
      this.__checkForBackdoorStraightDraw(rankIndexes, drawInfo, straightDrawInfoFromCommunityCards);
    }
  },
  __checkForOpenEndedStraightDraw: function (rankIndexes, drawInfo, straightDrawInfoFromCommunityCards, shortDeck) {
    if (
      !!straightDrawInfoFromCommunityCards &&
      straightDrawInfoFromCommunityCards.straight &&
      straightDrawInfoFromCommunityCards.straight.type === 'open ended'
    ) {
      return;
    }

    let fourRankIndexes;

    for (let i = 0; i <= rankIndexes.length - 4; i++) {
      fourRankIndexes = rankIndexes.slice(i, i + 4);

      if (
        (fourRankIndexes[0] === 0) || // akqj isn't an oesd
        (!shortDeck && (fourRankIndexes[3] === 13)) || // 432a isn't an oesd
        (shortDeck && (fourRankIndexes[3] === 9)) // 432a isn't an oesd
      ) {
        continue;
      }

      else if (helpers.checkIfRankIndexesAreSequential(fourRankIndexes)) {
        drawInfo.straight = {
          id: 'oesd',
          type: 'open ended',
          highCardRank: constants.ranks[fourRankIndexes[0]]
        };
        break;
      }
    }
  },
  __checkForDoubleGutshotStraightDraw: function (rankIndexes, drawInfo, straightDrawInfoFromCommunityCards) {
    if (
      !!straightDrawInfoFromCommunityCards &&
      straightDrawInfoFromCommunityCards.straight &&
      straightDrawInfoFromCommunityCards.straight.type === 'open ended'
      // double gutshot on board not possible
    ) {
      return;
    }


    let fiveRankIndexes;

    for (let i = 0; i <= rankIndexes.length - 5; i++) {
      fiveRankIndexes = rankIndexes.slice(i, i + 5);

      if (
        (fiveRankIndexes[0] + 2 === fiveRankIndexes[1]) && // eg. aq
        (fiveRankIndexes[1] + 1 === fiveRankIndexes[2]) && // eg. qj
        (fiveRankIndexes[2] + 1 === fiveRankIndexes[3]) && // eg. jt
        (fiveRankIndexes[3] + 2 === fiveRankIndexes[4])    // eg. t8
      ) {
        drawInfo.straight = {
          id: 'doubleGutshot',
          type: 'double gutshot',
          highCardRank: constants.ranks[fiveRankIndexes[0]]
        };
        break;
      }
    }
  },
  __checkForGutshotStraightDraw: function (rankIndexes, drawInfo, straightDrawInfoFromCommunityCards, shortDeck) {
    if (
      !!straightDrawInfoFromCommunityCards &&
      straightDrawInfoFromCommunityCards.straight &&
      (
        straightDrawInfoFromCommunityCards.straight.type === 'open ended' ||
        // double gutshot on board not possible
        straightDrawInfoFromCommunityCards.straight.type === 'gutshot'
      )
    ) {
      return;
    }

    let fourRankIndexes;
    let oneTwoThreeFourGutshotPresent; // akqj_
    let twoThreeFourFiveGutshotPresent; // _432a
    let oneTwoThreeFiveGutshotPresent; // eg. akq_t
    let oneTwoFourFiveGutshotPresent; // eg. ak_jt
    let oneThreeFourFiveGutshotPresent; // eg. a_qjt

    for (let i = 0; i <= rankIndexes.length - 4; i++) {
      fourRankIndexes = rankIndexes.slice(i, i + 4);
      oneTwoThreeFourGutshotPresent = (
        (fourRankIndexes[0] === 0) &&
        (fourRankIndexes[1] === 1) &&
        (fourRankIndexes[2] === 2) &&
        (fourRankIndexes[3] === 3)
      );
      if (!shortDeck) {
        twoThreeFourFiveGutshotPresent = (
          (fourRankIndexes[0] === 10) &&
          (fourRankIndexes[1] === 11) &&
          (fourRankIndexes[2] === 12) &&
          (fourRankIndexes[3] === 13)
        );
      } else {
        twoThreeFourFiveGutshotPresent = (
          (fourRankIndexes[0] === 6) &&
          (fourRankIndexes[1] === 7) &&
          (fourRankIndexes[2] === 8) &&
          (fourRankIndexes[3] === 9)
        );
      }
      oneTwoThreeFiveGutshotPresent = (
        (fourRankIndexes[0] + 1 === fourRankIndexes[1]) &&
        (fourRankIndexes[1] + 1 === fourRankIndexes[2]) &&
        (fourRankIndexes[2] + 2 === fourRankIndexes[3])
      );
      oneTwoFourFiveGutshotPresent = (
        (fourRankIndexes[0] + 1 === fourRankIndexes[1]) &&
        (fourRankIndexes[1] + 2 === fourRankIndexes[2]) &&
        (fourRankIndexes[2] + 1 === fourRankIndexes[3])
      );
      oneThreeFourFiveGutshotPresent = (
        (fourRankIndexes[0] + 2 === fourRankIndexes[1]) &&
        (fourRankIndexes[1] + 1 === fourRankIndexes[2]) &&
        (fourRankIndexes[2] + 1 === fourRankIndexes[3])
      );

      if (
        oneTwoThreeFourGutshotPresent ||
        twoThreeFourFiveGutshotPresent ||
        oneTwoThreeFiveGutshotPresent ||
        oneTwoFourFiveGutshotPresent ||
        oneThreeFourFiveGutshotPresent
      ) {
        drawInfo.straight = {
          id: 'gutshot',
          type: 'gutshot',
        };
        break;
      }
    }
  },
  __checkForBackdoorStraightDraw: function (rankIndexes, drawInfo, straightDrawInfoFromCommunityCards) {
    if (
      !!straightDrawInfoFromCommunityCards &&
      straightDrawInfoFromCommunityCards.straight
    ) {
      return;
    }

    let threeRankIndexes;
    let oneTwoThreeBackdoorStraightDrawPresent; // eg. akq__
    let oneTwoFourBackdoorStraightDrawPresent; // eg. ak_j_
    let oneTwoFiveBackdoorStraightDrawPresent; // eg. ak__t
    let oneThreeFourBackdoorStraightDrawPresent; // eg. a_qj_
    let oneThreeFiveBackdoorStraightDrawPresent; // eg. a_q_t
    let oneFourFiveBackdoorStraightDrawPresent; // eg. a__jt

    for (let i = 0; i <= rankIndexes.length - 3; i++) {
      threeRankIndexes = rankIndexes.slice(i, i + 3);
      oneTwoThreeBackdoorStraightDrawPresent = (
        (threeRankIndexes[0] + 1 === threeRankIndexes[1]) &&
        (threeRankIndexes[1] + 1 === threeRankIndexes[2])
      );
      oneTwoFourBackdoorStraightDrawPresent = (
        (threeRankIndexes[0] + 1 === threeRankIndexes[1]) &&
        (threeRankIndexes[1] + 2 === threeRankIndexes[2])
      );
      oneTwoFiveBackdoorStraightDrawPresent = (
        (threeRankIndexes[0] + 1 === threeRankIndexes[1]) &&
        (threeRankIndexes[1] + 3 === threeRankIndexes[2])
      );
      oneThreeFourBackdoorStraightDrawPresent = (
        (threeRankIndexes[0] + 2 === threeRankIndexes[1]) &&
        (threeRankIndexes[1] + 1 === threeRankIndexes[2])
      );
      oneThreeFiveBackdoorStraightDrawPresent = (
        (threeRankIndexes[0] + 2 === threeRankIndexes[1]) &&
        (threeRankIndexes[1] + 2 === threeRankIndexes[2])
      );
      oneFourFiveBackdoorStraightDrawPresent = (
        (threeRankIndexes[0] + 3 === threeRankIndexes[1]) &&
        (threeRankIndexes[1] + 1 === threeRankIndexes[2])
      );

      if (
        oneTwoThreeBackdoorStraightDrawPresent ||
        oneTwoFourBackdoorStraightDrawPresent ||
        oneTwoFiveBackdoorStraightDrawPresent ||
        oneThreeFourBackdoorStraightDrawPresent ||
        oneThreeFiveBackdoorStraightDrawPresent ||
        oneFourFiveBackdoorStraightDrawPresent
      ) {
        drawInfo.straight = {
          id: 'backdoorStraightDraw',
          type: 'backdoor',
        };
        break;
      }
    }
  },
  _checkForTopPairDraw: function (holeCards, communityCards, drawInfo) {
    let holeCardOneRank = holeCards[0][0];
    let holeCardTwoRank = holeCards[1][0];
    let highestBoardCardRank = utilities.ranks.getHighestRankFromCards(communityCards);
    let isFirstHoleCardAnOvercard = utilities.ranks.isFirstRankLargerThanSecond(holeCardOneRank, highestBoardCardRank);
    let isSecondHoleCardAnOvercard = utilities.ranks.isFirstRankLargerThanSecond(holeCardTwoRank, highestBoardCardRank);

    if (isFirstHoleCardAnOvercard && isSecondHoleCardAnOvercard) {
      drawInfo.topPair = {
        id: 'twoOvercards',
        type: 'two overcards',
      };
    } else if (isFirstHoleCardAnOvercard || isSecondHoleCardAnOvercard) {
      drawInfo.topPair = {
        id: 'oneOvercard',
        type: 'one overcard',
      };
    }
  },
};



// WEBPACK FOOTER //
// ./src/services/simulator/get-info-from-combined-cards/get-draw-info.js